import React from "react";
import { Input } from "semantic-ui-react";
import PublicationDropdown from "components/dropdowns/reactselect/PublicationDropdown";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { routes } from "utilities/routing/generatedRoutes";
import CulturesTemplateDropdown from "components/dropdowns/reactselect/CulturesTemplateDropdown";


interface State {
  userDefaults: server.dto.UpdateUserDefaultsPreferenceInstruction
}

export default class DefaultsPanel extends React.Component<object, State> {
  state: State = {
    userDefaults: site.userPreference.defaults
  };

  onSave = async () => {
    await window.CoreApi.UserPreference.UpdateDefaults(this.state.userDefaults);
    window.location.href = routes.personal_SettingMenu().absolute;
  };

  updateProps = <T extends keyof server.dto.UpdateUserDefaultsPreferenceInstruction>(propName: T, value: server.dto.UpdateUserDefaultsPreferenceInstruction[T]) => {
    this.setState({
      userDefaults: {
        ...this.state.userDefaults,
        [propName]: value
      }
    });
  };

  onDefaultSalutationChange = (_, { value }) => {
    this.updateProps("salutation", value);
  };

  onContactCultureChange = (value: server.dto.LCID) => {
    this.updateProps("contactCulture", value);
  };

  onDefaultPublicationChange = (_, { value }) => {
    this.updateProps("publication", value);
  };

  onDefaultVisibleToExternalForNewTaskChange = () => {
    this.updateProps("visibleToExternalForNewUserTask", !this.state.userDefaults.visibleToExternalForNewUserTask);
  };

  onDefaultVisibleToExternalForNewNoteChange = () => {
    this.updateProps("visibleToExternalForNewNote", !this.state.userDefaults.visibleToExternalForNewNote);
  };

  onDefaultVisibleToExternalForNewEmailChange = () => {
    this.updateProps("visibleToExternalForNewEmail", !this.state.userDefaults.visibleToExternalForNewEmail);
  };

  onDefaultVisibleToExternalForNewFileChange = () => {
    this.updateProps("visibleToExternalForNewFile", !this.state.userDefaults.visibleToExternalForNewFile);
  };

  public render(): JSX.Element {
    const {
      publication,
      salutation
    } = this.state.userDefaults;

    return (
      <>
        <table className="s1_table clean rowspace">
          <tbody>
            <tr>
              <th colSpan={2}>{RESX.Contact.resxContact}</th>
            </tr>
            <tr>
              <td>
                {RESX.Contact.Salutation}
              </td>
              <td>
                <Input
                  fluid
                  maxLength={serverReference.constants.contact.maxSalutationLength}
                  value={salutation}
                  onChange={this.onDefaultSalutationChange} />
              </td>
            </tr>
            <tr>
              <td>
                {RESX.Language.resxLanguage}
              </td>
              <td>
                <CulturesTemplateDropdown
                  value={this.state.userDefaults.contactCulture}
                  onChange={this.onContactCultureChange}
                />
              </td>
            </tr>
            <tr>
              <th colSpan={2}>{RESX.Show.NewShow}</th>
            </tr>
            <tr>
              <td>
                {RESX.SelectionManager.Publication}
              </td>
              <td>
                <PublicationDropdown
                  value={publication}
                  onChange={v => { this.updateProps("publication", v); }}
                />
              </td>
            </tr>
            <tr>
              <th colSpan={2}>{RESX.OptionsPanel.NewTask}</th>
            </tr>
            <tr>
              <td>
                {RESX.GeneralLabels.Visible}

              </td>
              <td>
                <Checkbox
                  onChange={this.onDefaultVisibleToExternalForNewTaskChange}
                  checked={this.state.userDefaults.visibleToExternalForNewUserTask}
                  label={RESX.GeneralLabels.VisibleToExternalUsers}
                />
              </td>
            </tr>
            <tr>
              <th colSpan={2}>{RESX.OptionsPanel.NewNote}</th>
            </tr>
            <tr>
              <td>
                {RESX.GeneralLabels.Visible}
              </td>
              <td>
                <Checkbox
                  onChange={this.onDefaultVisibleToExternalForNewNoteChange}
                  checked={this.state.userDefaults.visibleToExternalForNewNote}
                  label={RESX.GeneralLabels.VisibleToExternalUsers}
                />
              </td>
            </tr>
            <tr>
              <th colSpan={2}>{RESX.OptionsPanel.NewEmail}</th>
            </tr>
            <tr>
              <td>
                {RESX.GeneralLabels.Visible}
              </td>
              <td>
                <Checkbox
                  onChange={this.onDefaultVisibleToExternalForNewEmailChange}
                  checked={this.state.userDefaults.visibleToExternalForNewEmail}
                  label={RESX.GeneralLabels.VisibleToExternalUsers}
                />
              </td>
            </tr>
            <tr>
              <th colSpan={2}>{RESX.File.NewFile}</th>
            </tr>
            <tr>
              <td>
                {RESX.GeneralLabels.Visible}
              </td>
              <td>
                <Checkbox
                  onChange={this.onDefaultVisibleToExternalForNewFileChange}
                  checked={this.state.userDefaults.visibleToExternalForNewFile}
                  label={RESX.GeneralLabels.VisibleToExternalUsers}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="flex justify-end margin-top-bigger">
          <button
            type="button"
            onClick={this.onSave}
            className="button-new primary">
            {RESX.Buttons.btnSave}
          </button>
        </div>
      </>
    );
  }
}
